import React, { useState, useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSnackbar } from 'notistack';
import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';
import { ProductContext } from '../../ProductProvider';
import Preloader from '../../components/Preloader/Preloader';
import ReportHeader from './ReportHeader';
import BookReport from './BookReport';
import IssueReport from './IssueReport';
import JournalIssuesReport from './JournalIssuesReport';
import BookSearch from '../search/BooksSearch';
import './Reports.css';

const config = require('../../config.json');

export default function HomeReports() {
  const { validateLogin, loggedUser } = useContext(ProductContext);
  const { enqueueSnackbar } = useSnackbar();

  const [loaded, setLoaded] = useState(false);
  const [reportName, setReportName] = useState('JournalIssues');
  const [searchResult, setSearchResult] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [searchTopic, setSearchTopic] = useState('AccessionNo');

  useEffect(() => {
    if (!loggedUser.isAuthenticated) {
      validateLogin();
    } else {
      if (reportName === 'Books') {
        handleBookSearch();
      } else {
        setLoaded(true);
      }
    }
  }, [loggedUser, reportName]);

  const handleBookSearch = async () => {
    try {
      setLoaded(false);
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
      const clientID = loggedUser.website || 'VJCollege';

      const response = await axios.get(`${config.api.invokeURL}/vjlibrary/reports/books?clientID=${clientID}`, {
        headers: {
          Authorization: idToken,
          'x-api-key': config.api.key
        }
      });

      const data = Array.isArray(response.data) ? response.data : [];
      setSearchResult(data);
      setLoaded(true);
      enqueueSnackbar('Books Report loaded successfully', { variant: 'success' });
    } catch (error) {
      console.error('Error fetching book reports:', error);
      enqueueSnackbar('Error Occurred - ' + (error.response?.data?.message || error.message), { variant: 'warning' });
      setLoaded(true);
    }
  };

  const handleToggleReport = (event, item) => {
    if (event) event.preventDefault();
    setReportName(item);
  };

  return (
    <div className="reports-container container">
      <Helmet>
        <title>Reports & Analytics | Flynn - Meagher Library - Vidyajyoti College</title>
        <meta
          name="description"
          content="Comprehensive library analytics, circulation tracking, books inventory, and journal serials reports for Vidyajyoti College of Theology."
        />
      </Helmet>

      {!loaded && <Preloader show={true} />}

      {/* Hero Header Banner */}
      <div className="reports-hero-header">
        <div>
          <h1 className="reports-hero-title">
            <i className="bi bi-graph-up-arrow"></i> Library Analytics & Reports
          </h1>
          <p className="reports-hero-subtitle">
            Executive circulation metrics, catalogue inventory breakdown, and serials tracking dashboard.
          </p>
        </div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <span className="reports-hero-badge">
            <i className="bi bi-clock"></i> Updated Live
          </span>
          <span className="reports-hero-badge">
            <i className="bi bi-building"></i> {loggedUser.website || 'VJCollege'}
          </span>
        </div>
      </div>

      {/* Modern Tab Switcher */}
      <ReportHeader handleToggleReport={handleToggleReport} reportName={reportName} />

      {/* Report Content Panels */}
      <div className="reports-content-panel">
        {reportName === 'JournalIssues' && (
          <JournalIssuesReport />
        )}

        {reportName === 'Books' && (
          <BookReport
            searchResult={searchResult}
            setSearchTopic={setSearchTopic}
            setSearchValue={setSearchValue}
            searchValue={searchValue}
            searchTopic={searchTopic}
          />
        )}

        {reportName === 'Issue' && (
          <IssueReport
            setSearchTopic={setSearchTopic}
            setSearchValue={setSearchValue}
            searchValue={searchValue}
            searchTopic={searchTopic}
          />
        )}


        {/*reportName === 'Custom' && (
          <div className="reports-filter-card">
            <div className="reports-filter-title mb-3">
              <i className="bi bi-search text-primary"></i> Advanced Catalogue Search & Report Generator
            </div>
            <BookSearch />
          </div>
        )*/}
      </div>
    </div>
  );
}
